import axios from 'axios'
import Router from '@/router/index'
import { showToast } from 'vant'
import qs from 'qs'
import hybrid from "@/utils/hybrid.js"
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 30000
})

function getUrl(){
  const url = service.defaults.baseURL;
  return url
}
function headers(){
  let token = ''
  if (sessionStorage.getItem('token')) {
    token = sessionStorage.getItem('token')
  }
  const hs =  {
    'Content-Type': 'application/x-www-form-urlencoded',
    'timeStamp': new Date().getTime(),
    'machineCode': 'test',
    'terminal': 'PC',
    'versionCode': '1.0.0',
    'channelCode': '000000',
    'authorization': token
  };
  return hs
}
function post(url, data) {
  return new Promise((resolve, reject) => {
    let token = ''
    if (sessionStorage.getItem('token')) {
      token = sessionStorage.getItem('token')
    }
    service.post(url, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'timeStamp': new Date().getTime(),
        'machineCode': 'test',
        'terminal': 'PC',
        'versionCode': '1.0.0',
        'channelCode': '000000',
        'authorization': token
      },
    }).then((res) => {
      resolve(res)
      if (res.data.code == 700 || res.data.code == 701) {
        if (!hybrid.isValid) {
          showToast('登录已过期')
          Router.replace({ path: 'Login' })
        }
      } else if (res.data.code !== 0) {
        showToast(res.data.message)
      }
    }).catch((err) => {
      showToast(err)
      reject(err)
    })
  })
}

function postJson(url, data) {
  return new Promise((resolve, reject) => {
    let token = ''
    if (sessionStorage.getItem('token')) {
      token = sessionStorage.getItem('token')
    }
    service.post(url, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
        'timeStamp': new Date().getTime(),
        'machineCode': 'test',
        'terminal': 'PC',
        'versionCode': '1.0.0',
        'channelCode': '000000',
        'authorization': token
      },
    }).then((res) => {
      resolve(res)
      if (res.data.code == 700 || res.data.code == 701) {
        if (!hybrid.isValid) {
          showToast('登录已过期')
          Router.replace({ path: 'Login' })
        }
      } else if (res.data.code !== 0) {
        showToast(res.data.message)
      }
    }).catch((err) => {
      showToast(err)
      reject(err)
    })
  })
}

async function upload(
  url,
  key,
  OSSAccessKeyId,
  policy,
  Signature,
  file,
  progress
) {
  const form = new FormData();
  form.append("key", key);
  form.append("OSSAccessKeyId", OSSAccessKeyId);
  form.append("policy", policy);
  form.append("signature", Signature);
  form.append("file", file);
  await service.post(url, form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: progress,
  });
}

//4.导入文件
export default {
  post,
  postJson,
  upload,
  getUrl,
  headers,
}
